"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2016-2017 Flowhub UG
//     NoFlo may be freely distributed under the MIT license
// ## Information Packets
//
// IP objects are the way information is transmitted between
// components running in a NoFlo network. IP objects contain
// a `type` that defines whether they're regular `data` IPs
// or whether they are the beginning or end of a stream
// (`openBracket`, `closeBracket`).
//
// The component currently holding an IP object is identified
// with the `owner` key.
//
// By default, IP objects may be sent to multiple components.
// If they're set to be clonable, each component will receive
// its own clone of the IP. This should be enabled for any
// IP object working with data that is safe to clone.
//
// It is also possible to carry metadata with an IP object.
// For example, the `datatype` and `schema` of the sending
// port is transmitted with the IP object.
// Valid IP types:
//   - 'data'
//   - 'openBracket'
//   - 'closeBracket'
module.exports = /*#__PURE__*/function () {
  _createClass(IP, null, [{
    key: "isIP",
    // Detects if an arbitrary value is an IP
    value: function isIP(obj) {
      return obj && _typeof(obj) === 'object' && obj.isIP === true;
    } // Creates as new IP object
    // Valid types: 'data', 'openBracket', 'closeBracket'

  }]);

  function IP(type) {
    var _this = this;

    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, IP);

    this.type = type || 'data';
    this.data = data;
    this.isIP = true;
    this.scope = null; // sync scope id

    this.owner = null; // packet owner process

    this.clonable = false; // cloning safety flag

    this.index = null; // addressable port index

    this.schema = null;
    this.datatype = 'all';

    if (_typeof(options) === 'object') {
      Object.keys(options).forEach(function (key) {
        _this[key] = options[key];
      });
    }

    return this;
  } // Creates a new IP copying its contents by value not reference


  _createClass(IP, [{
    key: "clone",
    value: function clone() {
      var _this2 = this;

      var ip = new IP(this.type);
      Object.keys(this).forEach(function (key) {
        var val = _this2[key];

        if (key === 'owner') {
          return;
        }

        if (val === null) {
          return;
        }

        if (_typeof(val) === 'object') {
          ip[key] = JSON.parse(JSON.stringify(val));
        } else {
          ip[key] = val;
        }
      });
      return ip;
    } // Moves an IP to a different owner

  }, {
    key: "move",
    value: function move(owner) {
      // no-op
      this.owner = owner;
      return this;
    } // Frees IP contents

  }, {
    key: "drop",
    value: function drop() {
      var _this3 = this;

      Object.keys(this).forEach(function (key) {
        delete _this3[key];
      });
    }
  }]);

  return IP;
}();